export enum BLUETOOTH_EVENT {
  scanDevices = 'scanBluetoothDevices',
  responseDevices = 'responseBluetoothDevices',
  connectDevice = 'connectBluetoothPrinter',
  responseConnectDeviceSuccess = 'responseConnectBluetoothPrinter',
  responseConnectDeviceFailed = 'responseConnectBluetoothPrinterError',
}
